import { useEffect, useRef } from 'react';

// ถามก่อนออกจากหน้า เมื่อยังมีงานที่ไม่ได้บันทึก / กำลังบันทึกค้างอยู่
//   ปุ่มย้อนกลับของเบราว์เซอร์ (ปัดย้อนบน trackpad ด้วย) = เปลี่ยนหน้าในแอพ (lib/route.js) → App เช็คที่ popstate
//   รีเฟรช / ปิดแท็บ = beforeunload → เบราว์เซอร์ขึ้นกล่องถามของมันเอง
//   (28 ต.ค. 69 — ตั้งแต่หน้าที่เปิดอยู่ไปอยู่ใน URL ปุ่มย้อนกลับใช้ในแอพได้ → ถอดฟอร์มที่กรอกค้างทิ้งเงียบ ๆ
//    ข้ามกล่อง "ยังไม่ได้บันทึกที่แก้ไว้ — ปิดเลยไหม?" ของหน้าแก้ไขสินค้า)
const guards = new Set();

// msg = ข้อความถาม (string) เมื่อยังออกไม่ได้ · null/'' = ออกได้
export function useLeaveGuard(msg) {
  const ref = useRef(msg);
  ref.current = msg;
  useEffect(() => {
    const g = () => ref.current || null;
    guards.add(g);
    return () => { guards.delete(g); };
  }, []);
}

// ข้อความของงานแรกที่ยังค้าง หรือ null ถ้าออกได้
export function leaveBlocker() {
  for (const g of guards) { const m = g(); if (m) return m; }
  return null;
}
